import { Box, Button, Card, Chip, Container, Grid } from '@mui/material'
import { Theme, styled } from '@mui/material/styles'
import { SxProps } from '@mui/system'
import { Carousel } from 'react-responsive-carousel'

interface StyleProps {
  lessonPlay: SxProps<Theme>
}

export const seminarGlobalStyles = (theme: Theme): StyleProps => ({
  lessonPlay: {
    color: theme.palette.grey[500],
    fontSize: '56px !important',
    '&.live': {
      color: theme.palette.error.main
    },
    '&.new': {
      color: theme.palette.success.main
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '32px !important'
    }
  }
})

export const VideoDetail = styled(Box)(({ theme }) => ({
  paddingBottom: '40%',
  position: 'relative',
  width: '75%',
  height: '100%',
  display: 'inline-block',
  [theme.breakpoints.down('sm')]: {
    paddingBottom: '56.25%',
    width: '100%',
    height: '70%'
  },
  [theme.breakpoints.down('xs')]: {
    '& iframe': {
      borderRadius: '8px !important'
    }
  },
  '& iframe': {
    borderRadius: '8px 0px 0px 8px'
  }
}))

export const LimitEmbed = styled(Container)(({ theme }) => ({
  padding: '0px !important',
  [theme.breakpoints.up('md')]: {
    '& iframe': {
      height: 500
    }
  },
  '& iframe': {
    width: '100%',
    border: 'none'
  },
  '& p': {
    margin: 0
  }
}))


export const BannerHeroDetail = styled(Box)(({ theme }) => ({
  position: 'relative',
  marginBottom: 32,
  boxSizing: 'border-box',
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  color: theme.palette.common.white,
  padding: 56,
  gap: 8,
  background: 'radial-gradient(124.34% 346.02% at -3.79% -4.78%, rgba(0, 0, 0, 0.53) 0%, rgba(46, 46, 46, 0.477) 100%)',
  backdropFilter: 'blur(6px)',
  borderRadius: 8,
  '& h4': {
    maxWidth: 500,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 3,
    overflow: 'hidden'
  },
  '&.hide': {
    display: 'none'
  },
  [theme.breakpoints.down('sm')]: {
    padding: 24
  }
}))

export const ChatDetail = styled(Box)(({ theme }) => ({
  paddingBottom: '40%',
  position: 'relative',
  width: '25%',
  height: '100%',
  display: 'inline-block',
  [theme.breakpoints.down('sm')]: {
    paddingBottom: '66.25%',
    width: '100%',
    height: '50%'
  },
  [theme.breakpoints.down('xs')]: {
    paddingBottom: '96.25%',
    '& iframe': {
      borderRadius: '8px !important'
    }
  },
  '& iframe': {
    borderRadius: '0px 8px 8px 0px'
  }
}))

export const ActionsResponsive = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center'
  }
}))

export const ActionsResponsiveRight = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center'
  }
}))

export const ImgPrimary = styled(Box)(({ theme }) => ({
  borderRadius: 8,
  margin: '0px 12px',
  height: 400,
  backgroundPosition: 'center center',
  backgroundSize: 'cover',
  maxHeight: 400,
  cursor: 'pointer',
  [theme.breakpoints.down('xs')]: {
    margin: 0
  }
}))

export const ContentPrimary = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  color: theme.palette.common.white,
  padding: 56,
  gap: 8,
  background: 'radial-gradient(96.02% 552.55% at 3.98% 59.64%, rgba(0, 0, 0, 0.6) 0%, rgba(255, 255, 255, 0) 100%)',
  '& h4': {
    maxWidth: 500,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 3,
    overflow: 'hidden'
  },
  [theme.breakpoints.down('sm')]: {
    padding: 24
  }
}))

export const LabelLive = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.common.white,
  '& svg': {
    color: theme.palette.common.white
  }
}))

export const LinkPrimary = styled(Button)(({ theme }) => ({
  color: theme.palette.common.white,
  textDecoration: 'underline',
  textUnderlinePosition: 'under',
  fontWeight: 300,
  display: 'flex',
  gap: 8,
  padding: 0,
  '&.dark': {
    color: theme.palette.grey[800],
    '&:hover, &:active': {
      textDecoration: 'underline',
      color: theme.palette.primary.main,
      backgroundColor: 'transparent'
    }
  },
  '&:hover': {
    textDecoration: 'underline',
    color: theme.palette.primary.main
  }
}))

export const CardItem = styled(Card)(({ theme }) => ({
  border: 'none',
  position: 'relative',
  boxShadow: '1px 1px 6px 0px rgb(0 0 0 / 14%) !important',
  borderRadius: 8,
  '& .MuiCardActionArea-focusHighlight': {
    backgroundColor: theme.palette.grey[800]
  },
  [theme.breakpoints.up('md')]: {
    boxSizing: 'border-box'
  }
}))

export const CarouselStyled = styled(Carousel)(() => ({
  marginTop: 24,
  '& .carousel': {
    borderRadius: 8
  }
}))

export const TalkerDateDetail = styled(Box)(() => ({
  // marginTop: '-24px',
  display: 'flex',
  gap: 16,
  flexDirection: 'column',
  '& p': {
    fontWeight: 500
  }
}))

export const TextReadyDetail = styled(Box)(() => ({
  marginTop: '-8px',
  textAlign: 'center',
  gap: 8,
  display: 'flex',
  flexDirection: 'column'
}))

export const ContainerDetail = styled(Box)(({ theme }) => ({
  marginTop: 32,
  borderTop: `3px solid ${theme.palette.grey[800]}`,
  padding: 32,
  justifyItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 32,
  height: 'fit-content',
  [theme.breakpoints.down('sm')]: {
    padding: 8
  },
  '&.noBorder': {
    border: 'none'
  },
  '& h4': {
    fontWeight: 700
  },
  '&.white': {
    marginTop: 8,
    gap: 24,
    color: theme.palette.common.white,
    borderTop: `3px solid ${theme.palette.common.white}`
  },
  [theme.breakpoints.down('xs')]: {
    padding: 0,
    paddingTop: 24
  }
}))

export const BtnLinkDetail = styled(Button)(() => ({
  marginLeft: 'auto',
  marginRight: 'auto'
}))

export const Lessons = styled(Card)(({ theme }) => ({
  position: 'relative',
  background: '#F5F6F6',
  marginTop: theme.spacing(4),
  borderRadius: 16,
  boxShadow: 'none',
  '&.active': {
    border: '2px solid',
    borderColor: theme.palette.error.main,
    background: '#FAECF0'
  },
  '&:hover': {
    cursor: 'pointer',
    background: theme.palette.error.light
  },
  '& h6': {
    fontWeight: 500
  },
  '&.block': {
    border: 'none',
    background: theme.palette.grey[100],
    '&:hover': {
      background: theme.palette.grey[100]
    }
  }
}))
